import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Login from "./view/Loging/Login";
import Home from "./view/Home/Home";
import PrivateRoute from '../src/Components/PrivateRoute';
import GenerarTicket from './view/Tickets/GenerarTicket';
import SeguimientoTicket from './view/Tickets/SeguimientoTicket';
import HistorialServicios from './view/Tickets/HistorialServicios';
import Layout from './Components/Layout/Layout';
import TicketHistorial from './view/Detail/Detail';
import Tecnico from './view/Tickets/Tecnico';
import Asignartec from './Components/Gesticket/Asignartecnico/Asignartecnico';
import Resolverticket from './Components/Gesticket/Resticket/Resolverticket';
import HistorialTicket from './view/Tickets/HistorialTicket/HistorialTicket';
import Cerarticket from './Components/Gesticket/Cerrarticket/Cerrarticket'
import { useSelector } from 'react-redux';
import Cerrarticket from './Components/Gesticket/Cerrarticket/Cerrarticket';
import Agreuser from './Components/Usuarios/Crearusuario/Crearusuario';
import Gettickalluser from './Components/Gesticket/HistorServicios/HistorialServAll'
import GetEquipo from './Components/Equipos/Crearequipos/Crearequipos'
import AsignacionEquipo from './Components/Equipos/Asignarequipos/Asignarequipos';
import ConsumosIsc from './Components/Consumo/Consumo';
import Estadxtec from './Components/Estadisticas/Estadisxtec';
import Tecnicomto from './view/Tickets/Tecinomto';
import GenerarTicketmto from './view/Tickets/GenerarTicketmto';
// import Aprobaragenda from './Components/Calendar/Aprobar';
import AsignartecMto from './Components/Gesticket/AsignartecnicoMto/AsignartecnicoMto';
import Gettickallusermto from './Components/Gesticket/HistorServiciosMto/HistorialServAllMto';
import Admini from './view/Tickets/Administracion';
import Agreactivo from './Components/Activos/CrearActivos/crearactivos';
import Histoasigna from './Components/Equipos/Historialasigna/HistoAsignacion';
import Resolverticketmto from './Components/Gesticket/ResticketMto/ResolverticketMto';


import Cerrarticketmto from './Components/Gesticket/Cerrarticketmto/Cerrarticketmto';
import DarBaja from './Components/Activos/DarBaja/DarBaja';

function App() {
    const usuario = useSelector(state => state.usuario);

    // Verifica si usuario.usuario está definido antes de acceder a rolid
    const userRoleId = usuario.usuario ? usuario.usuario.rolid : null;

    return (
        <div className="App">

            <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/" element={<PrivateRoute element={Layout} roles={[1, 2]} />}>
                    <Route path="/home" element={<Home />} />
                    <Route path="/generar-ticket" element={<GenerarTicket />} />
                    <Route path="/generar-ticketmto" element={<GenerarTicketmto />} />
                    <Route path="/seguimiento-ticket" element={<SeguimientoTicket />} />
                    <Route path="/agendamiento" element={<HistorialServicios />} />
                    <Route path="/detail/:ticket" element={<TicketHistorial />} />
                    <Route path="/histtick" element={<HistorialTicket />} />
                    <Route path="/cerrartick" element={<Cerrarticket />} />
                    <Route path="/cerrartickmto" element={<Cerrarticketmto />} />
                    {userRoleId === 1 && <Route path="/tecnico" element={<Tecnico />} />}
                    {userRoleId === 1 && <Route path="/asigtec" element={<Asignartec />} />}
                    {userRoleId === 1 && <Route path="/resoltick/:ticketId" element={<Resolverticket />} />}
                    {userRoleId === 1 && <Route path="/allhistorial/" element={<Gettickalluser />} />}
                    {userRoleId === 1 && <Route path="/adduser" element={<Agreuser />} />}
                    {userRoleId === 1 && <Route path="/addequipo" element={<GetEquipo />} />}
                    {userRoleId === 1 && <Route path="/asigequipo" element={<AsignacionEquipo />} />}
                    {userRoleId === 1 && <Route path="/consumo" element={<ConsumosIsc />} />}
                    {userRoleId === 1 && <Route path="/indicagest" element={<Estadxtec defaultAreaId={1} />} />}
                    {userRoleId === 1 && <Route path="/tecnicomto" element={<Tecnicomto />} />}
                    {/* {userRoleId === 1 && <Route path="/aprobaragenda" element={<Aprobaragenda/>} />} */}
                    {userRoleId === 1 && <Route path="/asigtecmto" element={<AsignartecMto />} />}
                    {userRoleId === 1 && <Route path="/allhistorialmto/" element={<Gettickallusermto />} />}
                    {userRoleId === 1 && <Route path="/historasig/" element={<Histoasigna />} />}
                    {userRoleId === 1 && <Route path="/indicagestmto" element={<Estadxtec defaultAreaId={6} />} />}
                    <Route path="/administ/" element={<Admini />} />
                    <Route path="/addactivo" element={<Agreactivo />} />
                    <Route path="/darbaja" element={<DarBaja />} />
                    {userRoleId === 1 && <Route path="/resoltickmto/:ticketId" element={<Resolverticketmto />} />}
                </Route>
                <Route path="*" element={<Navigate to="/login" />} />
            </Routes>

        </div>
    );
}

export default App;
